import classNames from "classnames";
import Color from "color";
import React from "react";

import css from "./heat_map_item.module.scss";
import { HeatMap } from "./heat_map_item.types";
import { HeatMapLabel } from "./heat_map_label";

type HeatMapItemProps = {
  shouldDisplayLabel?: boolean;
  label: string;
  bgColor: string | undefined;
} & HeatMap;

export const HeatMapItem = ({
  left,
  width,
  label,
  bgColor,
  shouldDisplayLabel
}: HeatMapItemProps): JSX.Element => {
  const style = {
    width,
    left,
    ...(bgColor && { background: bgColor })
  };
  return (
    <div
      className={classNames(css.item, { [css.lightBgColor]: !bgColor || Color(bgColor).isLight() })}
      style={style}
    >
      {shouldDisplayLabel && <HeatMapLabel label={label} rootClassName={css.label} />}
    </div>
  );
};
